import React from 'react';
import './../Components/css/blog.css';
import { Link, useParams } from 'react-router-dom';
import { FiArrowLeft, FiCalendar } from 'react-icons/fi';
import BlogBanner from './BlogBanner';
import WhatWeSolve from './WhatWeSolve';
import { StoriesData } from '../Components/storiesMetaData';
import NotFound from './NotFound';
import Navbar2 from '../Components/Navbar2.js';
import './StoryDetail.css';
export default function Blog() {

	const { name } = useParams();
	const slug = name?.toLowerCase();
	const story = StoriesData.find((item) => item.url.toLowerCase() === slug);

	if (!story) {
		return <NotFound />;
	}
	return (
		<div>
			<Navbar2/>
			<main className="voices-story-page" id="voices-main" aria-label={`${story.customer} customer story`}>
				<BlogBanner story={story} />
				<WhatWeSolve story={story} />
				<div className="voices-story-body" dangerouslySetInnerHTML={{ __html: story.storyDetail || '' }} />
				<nav className="voices-story-return" aria-label="More customer stories">
					<Link to="/work"><FiArrowLeft aria-hidden="true" />All customer stories</Link>
					<a href="https://calendly.com/info-gmgd/30min" target="_blank" rel="noopener noreferrer"><FiCalendar aria-hidden="true" />Book a meeting</a>
				</nav>
			</main>
		</div>
	);
}
